import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class labelSelectCtrl implements IController {

  labelName: any;
  options: any;
  excludeLabelNames: any;
  onChange: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.excludeLabelNames) {
      this.excludeLabelNames = [];
    }
  };

  isDisabled(label) {
    return _.indexOf(this.excludeLabelNames, label.name) !== -1;
  }
}

angular
  .module('bringoz.admin.labels')
  .component('labelSelect', {
    bindings: {
      labelName: '<',
      options: '<',
      excludeLabelNames: '<?',
      onChange: '&'
    },
    template: require('./label-select.html').default,
    controller: labelSelectCtrl
  });
